<template>
  <v-app>
    <header-comp />
    <v-main class="main-content">
      <router-view />
    </v-main>
    <footer-comp />
  </v-app>
</template>

<script>
  import HeaderComp from './components/header-comp';
  import FooterComp from './components/footer-comp';

  export default {
    name: 'App',
    components: {
      HeaderComp,
      FooterComp
    },
    metaInfo: {
      title: 'Turn 10 Racing'
    },
  };
</script>

<style scoped>
  .main-content {
    background: var(--t10-bg);
  }
</style>
